  import React, { useState, useEffect} from 'react';
import "../assets/css/styles.table.css"
import Layout from './Layout.js';
//for table
import Box from '@mui/material/Box';
import ConfirmationButton from '../components/ConfirmationButton.js';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import FormControl from '@mui/material/FormControl';
import ApprovalDetailDialog from './ApprovalDetailDialog.js';
import Bindcomponent from '../utils/bindcomponent.js';
import {useRequestMaterial} from '../hook/RequestMaterialHook.js'
  const RequestMaterialApproval = () => {
    const {message,setmessage,tipe,settipe,rows,columns,approvalopen,setapprovalopen,rowsDetail,projectId,
         openRetention,handleRetentionClose,notes,setNotes,handleSave,selectedOptionProject,handleSelectedProject,
         openMaterialDetail,setOpenMaterialDetail, columnsDetail
    } = useRequestMaterial();
    return (
    <>
  <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
  <div className='pd'><b> REQUEST MATERIAL APPROVAL LIST</b> 
 
  </div>
 
  <div className="pd">
     
  <Box sx={{ width: 1 }} >
      <Bindcomponent component='DynamicSelect'  label={`{name} --- {subject}`} value={"id"} selectedvalue={selectedOptionProject}  onChange={(option) => {
                            handleSelectedProject(option)
                            }}
                            url={"GetAllListPO"} id="projectSelect" disabled={false} required={false} appendTopOption={[{label :'ALL PROJECT', value :"00000000000000"}]}></Bindcomponent>  
      <Box sx={{ height: "100%" }} >
        <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} rowid={"id"} name="rakapprovalgrid" ></Bindcomponent>
        
      </Box>
    </Box>
    </div>
 

      <Dialog
        open={openRetention}
        onClose={handleRetentionClose}
         maxWidth={"sm"}
        fullWidth={true}
        
      >
        
        <form id="formRetention" onSubmit={handleSave} >
        <DialogContent>
          <DialogContentText>
          <h4>Note</h4><br></br>
          
            <hr></hr>
          </DialogContentText>
         
           <FormControl sx={{ m: 1}} size="small" > 
          
              <div className='form-group row'>
                {/* <label class="col-sm-4">Retention</label> */}
                <div class="col-sm-12">
                <textarea  rows="5" cols="70"   className="form-control"  value={notes} onChange={(e) => setNotes(e.target.value)} required  />
              </div>
               
            </div>
             
          
           </FormControl>       
           <hr></hr>
        </DialogContent>
        <DialogActions>
          <button className='btn btn-danger' onClick={() => handleRetentionClose()} type="button">CANCEL</button>
          {/* <button className='btn btn-primary' type="submit">SAVE1</button>   */}
          <ConfirmationButton classname='btn btn-primary' text="Do you want save this data?" type="submit"  title="Save"  formid="formRetention" id="btnSubmit" >
               SAVE    
           </ConfirmationButton>
        </DialogActions>
        </form>    
      </Dialog>

      <Dialog
        open={openMaterialDetail}
        onClose={(e) => setOpenMaterialDetail(false)}
         maxWidth={"md"}
        fullWidth={true}
        
      >
        
        
        <DialogContent>
          <DialogContentText>
          <h4>Detail</h4><br></br>
          
            <hr></hr>
          </DialogContentText>
           <Bindcomponent component='DynamicDataGrid' customcolumns={columnsDetail} rows={rowsDetail} rowid={"id"} name="rakapprovalgrid2" ></Bindcomponent>   
           <hr></hr>
        </DialogContent>
        <DialogActions>
          <button className='btn btn-danger' onClick={() => setOpenMaterialDetail(false)} type="button">CANCEL</button>
           
        </DialogActions>
     
      </Dialog>
      </Layout>
    </>
  );
};

export default RequestMaterialApproval
 